import { useMemo } from 'react';
import { serverTypesFor, notificationFilterOptions } from './constants';
import { useGetNotificationsQuery } from '../notificationsApi';
import { transformMessageLinks } from '../utils/transformMessageLinks';

export function useNotificationsByType(
  filterType = '1',
  { search = '', pageLength = 25, reversed = false, transformParams = {} } = {}
) {
  const types = serverTypesFor(filterType);
  const params = { reversed, pageLength, ...(types ? { types } : {}) };

  const { data, isLoading, isError, error, refetch } = useGetNotificationsQuery(params, {
    selectFromResult: (result) => ({
      data: result.data || [],
      isLoading: result.isLoading,
      isError: result.isError,
      error: result.error,
      refetch: result.refetch,
    }),
  });

  const selectedFilterDef = useMemo(
    () => notificationFilterOptions.find((f) => f.value === String(filterType)) || notificationFilterOptions[1],
    [filterType]
  );

  const transformed = useMemo(
    () => transformMessageLinks(data || [], transformParams),
    [data, transformParams]
  );

  const items = useMemo(() => {
    const base = transformed || [];
    const byType = base.filter(selectedFilterDef?.fnc);
    if (!search) return byType;
    const query = String(search).toLowerCase();
    return byType.filter((item) => String(item?.message || '').toLowerCase().includes(query));
  }, [transformed, selectedFilterDef, search]);

  return { items, isLoading, isError, error, refetch };
}

// Convenience typed wrappers
export const useAllNotifications = (opts) => useNotificationsByType('1', opts);
export const useNewNotifications = (opts) => useNotificationsByType('0', opts);
export const useTaskNotifications = (opts) => useNotificationsByType('6', opts);
export const useDiscussionNotifications = (opts) => useNotificationsByType('3', opts);
export const useSalesNotifications = (opts) => useNotificationsByType('10', opts);
export const useArchivedNotifications = (opts) => useNotificationsByType('4', opts);

